export default __webpack_public_path__ + "static/media/stairway2.671fac36.webp";